<!-- 微信授权登录 -->
<template>
  <div class="login-container">
    <div class="box"></div>
    <p class="error">{{ error }}</p>
    <van-button
      v-if="loginFail"
      class="reload-btn"
      type="primary"
      block
      @click="redirect()"
      >重新加载</van-button
    >
  </div>
</template>

<script>
import { Toast } from 'vant'
import { jsApiSignByShuke, } from '@/config'
import { getQueryString, } from '@/utils/common'
import { getJsApiSignApi } from '@/api/communal'
import store from '@/store'
export default {
  name: 'Login',
  components: {},
  props: {},
  data() {
    return {
      loginFail: false,
      error: '',
      loginToast: null,
    }
  },
  created() {
    // this.loginToast = Toast.loading({
    //   message: '登录中...',
    //   duration: 0
    // })
    // 判断url参数是否存在code，不存在的话无法登录，permission逻辑有问题或者非法访问login
    const code = getQueryString('code')
    if (!code) {
      this.jumpAuth()
    } else {
      //二次登录bug解决
      store.commit('setLoginStatus', '1')
      sessionStorage.setItem('ydsh-ph-h5-bankv3-wxcode', code)
      this.redirect()
    }
  },
  methods: {
    // 活动微信授权code后，返回原来页面
    redirect() {
      let redirectRoute = store.state.landPageRoute
      redirectRoute = redirectRoute.slice(1)
      let redirectUrl = `${window.location.origin}${process.env.VUE_APP_ROUTER_BASE}${redirectRoute}`
      // hash路由模：
      if (process.env.VUE_APP_ENV === 'local') redirectUrl = `${window.location.origin}${process.env.VUE_APP_ROUTER_BASE}/#/${redirectRoute}`
      // console.log(redirectUrl);
      window.location.replace(redirectUrl)
    },
    // 微信授权
    jumpAuth() {
      const redirectUrl = encodeURIComponent(window.location.href.split('?redirect=')[0])
      // 1.记录上一个页面的地址
      const redirect = this.$route.query.redirect
      if (redirect) {
        store.commit('setLandPage', redirect)
      }

      // 请求接口获取appid
      getJsApiSignApi(jsApiSignByShuke.includes(redirect.split('?')[0]) ? 'sk' : 'ds').then(res => {
        // debugger
        try {
          const appId = res.data.appid
          const scope = 'snsapi_base'  // 静默授权
          // const scope = 'snsapi_userinfo'  // 主动授权
          const authUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirectUrl}&response_type=code&scope=${scope}#wechat_redirect`
          window.location.replace(authUrl)
        } catch (error) {
          console.error('微信授权', error);
          this.error = error
          // this.loginToast.clear()
          return
        }
      }).catch(error => {
        console.error('微信授权', error);
        this.error = error.message
        // this.loginToast.clear()
      })
    }

  }
}
</script>

<style lang="less" scoped>
.login-container {
  min-height: 100vh;

  .reload-btn {
    position: fixed;
    left: 0;
    bottom: 0;
  }
  .box {
    width: 100%;
    height: 200px;
  }
  .error {
    line-height: 2;
    text-align: center;
    padding: 30px;
  }
}
</style>
